import { DiGitBranch } from 'react-icons/di';
import { HiOutlinePresentationChartLine } from 'react-icons/hi';
import packageJson from '../../../package.json';

function Footer() {
  return (
    <div className="footer mt-1">
      <div className="footer-content d-flex justify-content-between pb-0">
        <div className="client-details">
          <span>
            <HiOutlinePresentationChartLine size={18} />
            CDMIS [{' '}
            <a href="https://plgsp.gov.np/" target="_blank" rel="noreferrer">
              PLGSP / MoFaGa
            </a>{' '}
            ]
          </span>
        </div>
        <p className="author text-muted">
          Powered by :{' '}
          <a href="https://ideabreed.net/" target="_blank" rel="noreferrer">
            Idea Breed IT Solution Pvt. Ltd.
          </a>
        </p>
        <div className="app-version">
          <span className='badge rounded-pill bg-secondary text-white"'>
            <DiGitBranch size={15} />
            {packageJson.version}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
